import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  EmailField,
  ReferenceManyField,
  Edit,
  DisabledInput,
  TextInput,
  SimpleForm,
  Create,
  SaveButton,
  EditButton,
  Toolbar,
  ViewTitle,
} from 'admin-on-rest'
import { Card } from 'material-ui/Card'
import { connect } from 'react-redux'

import { createInstructor } from '../reducers'

class AdminInstructorCreate extends React.Component {
  render() {
    return (
      <div className="create-page">
        <Card>
          <ViewTitle title={'Adauga lector'} />
          <SimpleForm
            save={values => {
              this.props.createInstructor(values)
            }}
          >
            <TextInput label="Prenume" source="firstName" />
            <TextInput label="Nume" source="lastName" />
            <TextInput label="Titulatura" source="entitling" />
            <TextInput label="Telefon" source="phoneNumber" />
            <TextInput source="email" label="Email" />
            <TextInput label="Parola" source="password" type="password" />
          </SimpleForm>
        </Card>
      </div>
    )
  }
}

export default connect(
  null,
  {
    createInstructor,
  },
)(AdminInstructorCreate)



// WEBPACK FOOTER //
// ./src/admin/AdminInstructorCreate.js